import { render, staticRenderFns } from "./cardReplacement.vue?vue&type=template&id=53533782&scoped=true&"
import script from "./cardReplacement.vue?vue&type=script&lang=js&"
export * from "./cardReplacement.vue?vue&type=script&lang=js&"
import style0 from "./cardReplacement.vue?vue&type=style&index=0&id=53533782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53533782",
  null
  
)

export default component.exports